import { getStatistics } from 'src/components/Chart/chart_get_stats_period';
import {
	rangeDates,
	rangeOptions,
	type chartControlsDataInterface,
} from '../Chart/chart_control_helpers';
import { getDeviceChartsConfig } from '../Chart/chart_config';
//Types
import type { Device } from 'src/types/Device';
import type { ChartConfig, ChartConfigInterface, StatisticsData } from 'src/types/Chart';
import type { PrecipitationUnit } from 'src/helpers/units/precipitation_unit';

type WSStatisticsType = 'temperature' | 'precipitation' | 'pressure';

export const CACHE_WS_STATISTICS_TIMEOUT = 60000 * 5;

export const getLast24WSStatistics = async (
	device: Device,
	type: WSStatisticsType,
	updateStatus = false,
): Promise<StatisticsData> => {
	const today = new Date();
	const currentPeriod = '24_hours';
	const rangeOption = rangeOptions.find((i) => i.period == currentPeriod);
	const time = rangeDates(today, rangeOption);
	const chartsConfig: ChartConfigInterface = getDeviceChartsConfig(device)[0];
	const chartConfig: ChartConfig = chartsConfig.charts.find((i) => i.name == type);
	const chartControlsData: chartControlsDataInterface = {
		time,
		format: 'Y-m-d H:i:s',
		rangeOption,
		currentPeriod,
	};
	if (type === 'precipitation') {
		if (!rainfallPerDevice[device.id]) {
			rainfallPerDevice[device.id] = {};
		}
		rainfallPerDevice[device.id].timestamp = Date.now();
	}
	let stats: StatisticsData;
	try {
		stats = await getStatistics(device, chartControlsData, chartConfig, chartsConfig.url);
		if (type === 'precipitation' && stats?.chartStatistic?.totalCounter) {
			const rainfall = stats.chartStatistic.totalCounter;
			rainfallPerDevice[device.id].rainfall = rainfall;
			rainfallPerDevice[device.id].unit = stats.chartData.units;
		}
	} catch (error) {
		if (updateStatus) {
			return null;
		}
		throw error;
	}
	return stats;
};

type RainfallPerDevice = { timestamp?: number; rainfall?: string; unit?: string };
const rainfallPerDevice: Record<string, RainfallPerDevice> = {};

export const getLast24WSRainfallStatus = (device: Device, unit: PrecipitationUnit): string => {
	const cacheResult: RainfallPerDevice = rainfallPerDevice[device.id];
	if (
		!cacheResult?.timestamp ||
		cacheResult?.unit !== unit ||
		cacheResult.timestamp < Date.now() - CACHE_WS_STATISTICS_TIMEOUT
	) {
		getLast24WSStatistics(device, 'precipitation', true);
	}
	return cacheResult?.rainfall || (unit === 'in' ? '0 in' : '0 mm');
};
